import type { Database } from "../../../src/integrations/supabase/types.ts";

type Tables = Database["public"]["Tables"];
type CheckedRelation<Relation> = Relation extends {
  foreignKeyName: infer ForeignKey extends string;
  referencedRelation: infer Target extends keyof Tables;
} ? { alias: string; foreignKey: ForeignKey; table: Target; columns: readonly (keyof Tables[Target]["Row"] & string)[]; join?: "inner" | "left" } : never;
type EdgeRelation<Table extends keyof Tables> = CheckedRelation<Tables[Table]["Relationships"][number]>;

/** SELECT columns and relationships checked against generated Database; joins default to inner. */
export function edgeColumns<Table extends keyof Database["public"]["Tables"]>(
  _table: Table,
  columns: readonly ((keyof Database["public"]["Tables"][Table]["Row"] & string)
    | `${keyof Database["public"]["Tables"][Table]["Row"] & string}::text`)[],
  relations: readonly EdgeRelation<Table>[] = [],
): string {
  return [columns.join(", "), ...relations.map(relation => {
    if (!/^[A-Za-z_][A-Za-z_0-9]*$/.test(relation.alias)) throw new Error("edge_relation_invalid");
    return `${relation.alias}:${relation.table}!${relation.foreignKey}!${relation.join ?? "inner"}(${relation.columns.join(",")})`;
  })].join(",");
}
